import { render, staticRenderFns } from "./SubNavigation.vue?vue&type=template&id=162caffe&lang=pug"
import script from "./SubNavigation.vue?vue&type=script&lang=js"
export * from "./SubNavigation.vue?vue&type=script&lang=js"
import style0 from "./SubNavigation.vue?vue&type=style&index=0&id=162caffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports